import React from 'react'
import ProductPrice from './ProductPrice'
import UnitDetails from './UnitDetails'

interface ProductPriceWithUnitProps {
  discountPrice?: number | string
  price: number | string
  unitDetails?: string
  margin?: boolean
  preset?: 'standard' | 'mini'
  align?: 'left' | 'center' | 'right'
}

const ProductPriceWithUnit = ({
  discountPrice,
  price,
  unitDetails,
  margin = false,
  preset = 'standard',
  align = 'left'
}: ProductPriceWithUnitProps) => {
  return (
    <div className={`product-details__info-price-wrapper${margin ? ' product-details__info-price-wrapper--margin' : ''}${align ? ` product-details__info-price-wrapper--${align}` : ''}${preset === 'mini' ? ' product-details__info-price-wrapper--mini' : ''}`}>
      <ProductPrice
        margin={false}
        discountPrice={discountPrice}
        price={price}
        preset={preset}
      />
      <UnitDetails unitDetails={unitDetails} />
    </div>
  )
}

export default ProductPriceWithUnit
